import { render } from "./sales-rep-dashboard-sections.vue?vue&type=template&id=4f506053&scoped=true"
import script from "./sales-rep-dashboard-sections.vue?vue&type=script&lang=js"
export * from "./sales-rep-dashboard-sections.vue?vue&type=script&lang=js"

import "./sales-rep-dashboard-sections.vue?vue&type=style&index=0&id=4f506053&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f506053"]])

export default __exports__